import {
    ChangeDetectionStrategy,
    Component,
    Input,
    OnChanges,
    OnInit,
} from '@angular/core';
import {
    ChangeOperation,
    ChangeTrackingValueFormatter,
    EntityChangeTrackingDto,
    FrameworkColumn,
    IEntity,
    ITableCellValueRenderer,
    SafeAny,
} from '@pf/shared-common';
import {
    ChangeDescription,
    computeChangeDescriptions,
    computeChangeText,
} from '@pf/shared/util-platform';

@Component({
    selector: 'platform-changes-cell-renderer',
    template: `
        @if (changeText) {
            <pf-text bold>{{ changeText }}</pf-text>
        }
        @if (changeDescriptions.length) {
            <ul class="change-descriptions">
                @for (desc of changeDescriptions; track desc.field) {
                    <li>{{ desc.description }}</li>
                }
            </ul>
        }
    `,
    styles: [
        `
            :host {
                display: block;

                .change-descriptions {
                    margin: 4px 0 0;
                    padding-left: 16px;
                    font-size: small;
                    color: var(--pf-secondary-color, rgba(0, 0, 0, 0.65));

                    li {
                        margin-bottom: 2px;
                    }
                }
            }
        `,
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class ChangesCellRendererComponent<T extends IEntity>
    implements ITableCellValueRenderer, OnInit, OnChanges
{
    @Input() value!: SafeAny;
    @Input() row!: EntityChangeTrackingDto<T>;
    @Input() column!: FrameworkColumn;
    @Input() customValueTransformer?: ChangeTrackingValueFormatter;
    @Input() excludedFields: string[] = [];

    changeText?: string;
    changeDescriptions: ChangeDescription[] = [];

    private _changes?: ChangeOperation[];

    ngOnInit(): void {
        this.updateChanges();
    }

    ngOnChanges(): void {
        this.updateChanges();
    }

    private updateChanges(): void {
        this._changes = this.row?.changes || [];
        this.changeText = computeChangeText(this._changes, this.excludedFields);
        this.changeDescriptions = computeChangeDescriptions(
            this._changes,
            this.row?.entity,
            this.customValueTransformer,
            this.excludedFields
        );
    }
}
